export default __webpack_public_path__ + "static/home-banner-bottom-b46eca0a3bcc76c36b8bc843aaf4d39f.png";